import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';
import { isOnboardingIncomplete } from '../utils/onboarding-status.util';

export const authGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (!storageService.hasToken()) {
    return true;
  }

  if (isOnboardingIncomplete(storageService.getDataUser())) {
    return true;
  }

  return router.createUrlTree(['/main']);
};
